import { atom, useAtom } from 'jotai';

const renameGroupAtom = atom<string | null>(null);

export const useRenameGroup = () => {
  const [groupIdToRename, setGroupIdToRename] = useAtom(renameGroupAtom);

  return {
    groupIdToRename,
    setGroupIdToRename,
  };
};
